import * as React from 'react';
import * as PropTypes from 'prop-types';
import clsx from 'clsx';
import { CheckCircleIcon, ErrorCircleIcon } from '../../icons'
import NumberTag from "../../number-tag/NumberTag";

const StepIcon = props => {
  const {
    active = false,
    className,
    completed = false,
    error = false,
    icon,
    ...other
  } = props;

  if (typeof icon === 'number' || typeof icon === 'string') {
    const classes = clsx(className, {
      'active': active,
      'error': error,
      'completed': completed
    });

    if (error) {
      return <ErrorCircleIcon className={classes} color="error" {...other}/>;
    }

    if (completed) {
      return <CheckCircleIcon className={classes} {...other}/>;
    }

    return (
        <NumberTag number={icon} color="outline" {...other}/>
    );
  }

  return icon;
};

StepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * Mark the step as failed.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

export default StepIcon;
